export const PDF_NORMALIZED_COORDINATE_SYSTEM =
  "pdf-cropbox-bottom-left-normalized-v1" as const;

export type PdfNormalizedCoordinateSystem =
  typeof PDF_NORMALIZED_COORDINATE_SYSTEM;

export type PdfNormalizedPoint = {
  x: number;
  y: number;
};

export type PdfNormalizedRect = {
  xMin: number;
  yMin: number;
  xMax: number;
  yMax: number;
};

export type TextQuoteAnchor = {
  kind: "quote";
  normalizationVersion: 1;
  exact: string;
  normalized: string;
  prefix: string;
  suffix: string;
  start: number;
  end: number;
};

export type TextPositionAnchor = {
  kind: "position";
  normalizationVersion: 1;
  position: number;
  prefix: string;
  suffix: string;
};

export type AnnotationTextAnchor = TextQuoteAnchor | TextPositionAnchor;

export type AnnotationTarget = {
  pageIndex: number;
  text: AnnotationTextAnchor | null;
  geometry: {
    coordinateSystem: PdfNormalizedCoordinateSystem;
    rects: PdfNormalizedRect[];
    point: PdfNormalizedPoint | null;
  };
};

export type ResolvedAnnotationTarget = {
  target: AnnotationTarget;
  status: "resolved" | "geometry-only" | "unresolved";
  transientGlyphRange: {
    start: number;
    end: number;
    renderGeneration: number;
  } | null;
};
